module.exports = __webpack_public_path__ + "front/img/46.f7929ee1.jpg";